import React, { useEffect, useState } from 'react';
import { FaPhoneAlt, FaShareAlt } from 'react-icons/fa';
import axios from 'axios';
import './WabaProfile.css';

const verticalOptions = [
  { value: '', label: 'Select a Category' },
  { value: 'ALCOHOL', label: 'Alcoholic Beverages' },
  { value: 'APPAREL', label: 'Clothing and Apparel' },
  { value: 'AUTO', label: 'Automotive' },
  { value: 'BEAUTY', label: 'Beauty, Spa and Salon' },
  { value: 'EDU', label: 'Education' },
  { value: 'ENTERTAIN', label: 'Entertainment' },
  { value: 'EVENT_PLAN', label: 'Event Planning and Service' },
  { value: 'FINANCE', label: 'Finance and Banking' },
  { value: 'GOVT', label: 'Public Service' },
  { value: 'GROCERY', label: 'Food and Grocery' },
  { value: 'HEALTH', label: 'Medical and Health' },
  { value: 'HOTEL', label: 'Hotel and Lodging' },
  { value: 'NONPROFIT', label: 'Non-profit' },
  { value: 'ONLINE_GAMBLING', label: 'Online Gambling & Gaming' },
  { value: 'OTC_DRUGS', label: 'Over-the-Counter Drugs' },
  { value: 'OTHER', label: 'Other' },
  { value: 'PHYSICAL_GAMBLING', label: 'Non-Online Gambling & Gaming' },
  { value: 'PROF_SERVICES', label: 'Professional Services' },
  { value: 'RESTAURANT', label: 'Restaurant' },
  { value: 'RETAIL', label: 'Shopping and Retail' },
  { value: 'TRAVEL', label: 'Travel and Transportation' }
];

const WabaProfile = ({ currenUser }) => {
  console.log(currenUser)
  const [profileData, setProfileData] = useState({
    profilePhoto: '',
    displayName: '',
    category: '',
    about: '',
    address: '',
    email: '',
    websites: [],
    phoneNumber: '',
    imageWabaId: '',
    profilePictureHandle: ''
  });

  const [changedFields, setChangedFields] = useState({});
  const [selectedImageFile, setSelectedImageFile] = useState(null);

  useEffect(() => {
    const fetchWabaProfile = async () => {
      try {
        const response = await axios.post('https://gambot.azurewebsites.net/api/Webhooks/GetWabaProfile', {
          organization: currenUser?.organization
        });

        const data = response.data;

        setProfileData({
          profilePhoto: data.profile_picture_url || '',
          displayName: data.display_name || '',
          category: data.vertical || '',
          about: data.about || '',
          address: data.address || '',
          email: Array.isArray(data.email) ? data.email.join(', ') : data.email || '',
          websites: data.websites || [],
          phoneNumber: '+'+ currenUser?.wabaNumber,
          imageWabaId: data.ImageWabaId || '',
          profilePictureHandle: data.profile_picture_handle || ''
        });
      } catch (error) {
        console.error('Error fetching WABA profile:', error);
      }
    };

    fetchWabaProfile();
  }, [currenUser]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setProfileData((prevData) => ({
      ...prevData,
      [name]: value
    }));

    setChangedFields((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleWebsitesChange = (e) => {
    const websites = e.target.value.split('\n');

    setProfileData((prevData) => ({
      ...prevData,
      websites
    }));

    setChangedFields((prev) => ({
      ...prev,
      websites
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const imageUrl = URL.createObjectURL(file);
    setProfileData((prevData) => ({
      ...prevData,
      profilePhoto: imageUrl
    }));

    setSelectedImageFile(file);
  };

  const handleSave = async () => {
    try {
      let updatedFields = { ...changedFields };

      // 1. If there's a new image file, upload it to CreateWabaMedia
      if (selectedImageFile) {
        const formData = new FormData();
        formData.append('File', selectedImageFile);
        formData.append('Org', currenUser?.organization);
        formData.append('file_type', selectedImageFile.type);
        formData.append('file_length', selectedImageFile.size.toString());

        const mediaRes = await axios.post('https://gambot.azurewebsites.net/api/Webhooks/CreateWabaMedia', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        if (mediaRes.data?.Success) {
          updatedFields.profile_picture_handle = mediaRes.data.mediaId;
          updatedFields.session_id = mediaRes.data.mediaSessionId;
          updatedFields.profile_picture_url = mediaRes.data.mediaUrl;
        } else {
          console.error('❌ Media upload failed');
          return;
        }
      }

      // 2. Send changed fields to update endpoint
      await axios.post('https://gambot.azurewebsites.net/api/Webhooks/UpdateWabaProfile', {
        organization: currenUser?.organization,
        wabaProfile: updatedFields
      });

      alert('✅ Profile updated successfully!');
      setChangedFields({});
      setSelectedImageFile(null);
    } catch (error) {
      console.error('❌ Failed to update WABA profile:', error);
      alert('❌ Failed to update WABA profile.');
    }
  };

  return (
    <div className="wabaProfile-container">
      <div className="wabaProfile-container-wrapper">
        <div className="wabaProfile-inputs-container">
          <div className="wabaProfile-input-field">
            <label>Profile Photo</label>
            <input type="file" accept="image/*" onChange={handleFileChange} />
          </div>
          <div className="wabaProfile-input-field">
            <label>Display Name</label>
            <input
              type="text"
              name="displayName"
              value={profileData.displayName}
              onChange={handleInputChange}
            />
          </div>
          <div className="wabaProfile-input-field">
            <label>Category</label>
            <select
              name="category"
              value={profileData.category}
              onChange={handleInputChange}
            >
              {verticalOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="wabaProfile-input-field">
            <label>About</label>
            <input
              type="text"
              name="about"
              value={profileData.about}
              onChange={handleInputChange}
            />
          </div>
          <div className="wabaProfile-input-field">
            <label>Address</label>
            <input
              type="text"
              name="address"
              value={profileData.address}
              onChange={handleInputChange}
            />
          </div>
          <div className="wabaProfile-input-field">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={profileData.email}
              onChange={handleInputChange}
            />
          </div>
          <div className="wabaProfile-input-field">
            <label>Websites (one per line)</label>
            <textarea
              name="websites"
              value={profileData.websites.join('\n')}
              onChange={handleWebsitesChange}
            />
          </div>
          <div className="wabaProfile-actions">
            <button className="save-button" onClick={handleSave}>💾 Save Changes</button>
          </div>
        </div>

        <div className="wabaProfile-preview-container">
  <div className="wabaProfile-phone-frame">
    <div className="wabaProfile-chat-header">
      <img
        className="wabaProfile-preview-image"
        src={profileData.profilePhoto || 'https://via.placeholder.com/100'}
        alt="Profile"
      />
      <div>
        <h2>{profileData.displayName || 'Business Name'}</h2>
        <p>{verticalOptions.find(v => v.value === profileData.category)?.label || 'Category'}</p>
        <p className="wabaProfile-about-text">{profileData.about || 'Business description...'}</p>
      </div>
    </div>
    <div className="wabaProfile-chat-body">
      <p><FaPhoneAlt /> {profileData.phoneNumber}</p>
      <p>{profileData.address}</p>
      <p>{profileData.email}</p>
      <div>
        <strong>Websites:</strong>
        <ul>
          {profileData.websites.map((site, index) => (
            <li key={index}>
              <a href={site} target="_blank" rel="noopener noreferrer">{site}</a>
            </li>
          ))}
        </ul>
      </div>
      <p style={{ marginTop: '1rem' }}>
        <FaShareAlt /> <a href={`https://wa.me/${profileData.phoneNumber}`} target="_blank" rel="noopener noreferrer">לשתף</a>
      </p>
    </div>
  </div>
</div>

      </div>
    </div>
  );
};

export default WabaProfile;
